export default __webpack_public_path__ + "static/media/bg-video-4.51945d6b.mp4";